import * as axios from "axios";
import { ArticleExtraData } from "articlePage/stateInterfaces";
import { addAxiosDateTransformerSettings } from "../../../../../utils/network/axiosDateTransformer";
import { Loader } from "../../../yPlusLoadMore/components/loader/loader";
import Slider from "react-slick";
import { GalhedAutoItemSlotProps, GalhedItemSlot } from "./galhedSlotItem";
import * as map from "lodash/map";
import { isWcmEditor } from "../../../../../config/serverConfig";
import classNames = require("classnames");

interface GalhedAutoItemsGalleryProps {
    componentaId?: string
    extraData?: any
    categoryId?: string
    gallerySeconds?: number
    numberOfManualItems?: number
    isMobileSite?: boolean
    isLtr?: boolean
    isVer2?: boolean
}

interface GalhedAutoItemsGalleryState {
    articles: ArticleExtraData[]
    showLoader: boolean
}

export class GalhedAutoItemsGallery extends React.Component<GalhedAutoItemsGalleryProps, GalhedAutoItemsGalleryState> {
    public static siteScriptName = "GalhedAutoItemsGallery"
    private slider: any;

    constructor(props) {
        super(props)
        this.state = {
            articles: (props.extraData && props.extraData.data) || [],
            showLoader: false
        }
    }

    componentDidUpdate(prevProps: GalhedAutoItemsGalleryProps) {
        if (isWcmEditor()) return;
        if (this.props.extraData !== prevProps.extraData) {
            this.setState({ articles: (this.props.extraData && this.props.extraData.data) || [] });
        }
    }

    componentDidMount() {
        if (isWcmEditor()) return;

        const { categoryId } = this.props;
        if (categoryId) {
            this.getArticles()
        }
        if (typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        }

        if (typeof window !== 'undefined') {
            window.addEventListener('pageshow', this.handlePageShow);
        }
    }

    componentWillUnmount() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
        if (typeof window !== 'undefined') {
            window.removeEventListener('pageshow', this.handlePageShow);
        }
    }

    private handleVisibilityChange = () => {
        if (document.visibilityState === 'visible' && this.slider) {
            this.slider.slickPlay();
        }
    }

    private handlePageShow = (event: PageTransitionEvent) => {
        if (event.persisted && this.slider) {
            this.slider.slickPlay();
        }
    }

    private pauseAndResumeAutoplay = () => {
        if (this.slider) {
            this.slider.slickPause();
        }
        setTimeout(() => {
            this.slider.slickPlay();
        }, this.props.gallerySeconds * 1000);
    }

    private getArticles = () => {
        const { componentaId, } = this.props
        const { articles } = this.state
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        this.setState(
            {
                articles: articles,
                showLoader: true,
            }
        );

        axiosInstance.get(`/iphone/json/api/article_list/${componentaId}/pageNumber/0`)
            .then((res: any) => {
                const recivedArticles = res.data.data as ArticleExtraData[];
                this.setState(
                    {
                        articles: [...articles, ...recivedArticles],
                        showLoader: false,
                    }
                );
            })
            .catch(err => console.error("error geting headline data:", err))
    }

    public render() {
        const { gallerySeconds, numberOfManualItems, isMobileSite, isVer2 } = this.props;
        const { articles, showLoader } = this.state;
        const maxVisibleItems = isVer2 && isMobileSite ? 2 : 3;
        const slidesToShow = isVer2
            ? Math.max(maxVisibleItems - numberOfManualItems, 1)
            : 3 - numberOfManualItems;
        let settings = {
            draggable: false,
            infinite: true,
            dots: false,
            slidesToShow,
            slidesToScroll: 1,
            ...(isVer2 ? { variableWidth: !isMobileSite } : {}),
            autoplay: true,
            autoplaySpeed: gallerySeconds * 1000,
            pauseOnHover: true,
            pauseOnFocus: true,
            pauseOnSwipe: isMobileSite,
            //swipeToSlide: isMobileSite,
            arrows: isVer2 ? true : !isMobileSite,
            rtl: !this.props.isLtr,
            centerMode: false,
            onSwipe: isMobileSite ? () => this.pauseAndResumeAutoplay() : undefined,
            initialSlide: this.props.isLtr ? 0 : articles.length - 1,
            swipe: isMobileSite,
            cssEase: "linear",
            touchMove: isMobileSite,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
        }
        let displayedArticles = map(articles, (article, index) => {
            let itemData: GalhedAutoItemSlotProps = {
                image: article.promotionImageDetails,
                title: article.title,
                roof: article.roof,
                link: article.publishedLink,
                fallenDate: article.topStoryData && article.topStoryData["Galhad-Article-Top-Story"] && article.topStoryData["Galhad-Article-Top-Story"].fallenDate ? article.topStoryData["Galhad-Article-Top-Story"].fallenDate : "",
                fallenDetails: article.topStoryData && article.topStoryData["Galhad-Article-Top-Story"] && article.topStoryData["Galhad-Article-Top-Story"].fallenDetails ? article.topStoryData["Galhad-Article-Top-Story"].fallenDetails : "",
                isVer2,
            }
            return itemData;
        })

        const isInEditMode = isWcmEditor();
        const isEmpty = !isInEditMode && isVer2 && !showLoader && displayedArticles.length === 0;
        const isTwoUp = isVer2 && isMobileSite && slidesToShow === 2;
        const isShowContent = !isInEditMode && !isEmpty;
        const styles = {
            width: isMobileSite ? `${(3 - numberOfManualItems) * 33.281}vw` : `${(3 - numberOfManualItems) * 201}px `,
            height: !isMobileSite && `141px`
        }

        return (
            <div className={classNames(`GalhedAutoItemsGallery`, { "isTwoUp": isTwoUp, "isEmpty": isEmpty, "inEditMode": isInEditMode })} style={isVer2 ? undefined : styles}>
                {isShowContent ?
                    <>
                        {showLoader && <Loader />}

                        <Slider {...settings} className={"galhedGalleryContent"} ref={slider => (this.slider = slider)}>
                            {map(displayedArticles, (article, i) => <GalhedItemSlot
                                key={i}
                                isVer2={isVer2}
                                roof={article.roof}
                                link={article.link}
                                image={article.image}
                                title={article.title}
                                fallenDate={article.fallenDate}
                                fallenDetails={article.fallenDetails}
                            />
                            )}
                        </Slider>
                    </>
                    :
                    <div className="noContentTitle">{__("Galhed Gallery")}</div>
                }
            </div>
        )
    }
}

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="slickArrow slickPrev" onClick={onClick} />
    );
}

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="slickArrow slickNext" onClick={onClick} />
    );
}
